<script>
export default {
    name: "login-banner",
    props: {
        title: {
            type: String,
            default: Lang.langGet('Welcome to Webinterface')
        },
        subTitle: {
            type: String,
            default: Lang.langGet('Create, design and publish your digital signage content with a few clicks!')
        }
    },
    inject: {
        appKey: {}
    },
    computed: {
        translations() {
            return {
                ewi: Lang.langGet('EWI'),
            }
        },
        bannerSrc() {
            if (this.appKey === 'support') return '/img/logo-knowledgebase.svg';

            return '/img/logo-easescreen.svg';
        },
    }
}
</script>

<template>
    <div class="login-header py-4 animate-slide-from-above">
        <img class="logo mb-4" :src="bannerSrc" :alt="translations.ewi" />
        <h2 class="text-center">{{ title }}</h2>
        <div class="text-center">{{ subTitle }}</div>
    </div>
</template>

<style scoped>
    .login-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .logo {
            vertical-align: text-bottom;
        }
    }

    @keyframes slideFromAbove {
        0% {
            transform: translateY(-50%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .animate-slide-from-above {
        animation: slideFromAbove 1s ease-out forwards;
    }
</style>
